import Layout from "@/components/v2/organisms/landing/layout/Layout";
import SEOHead from "@/components/SEOHead";
import ContactCardsSection from "@/components/v2/molecules/landing/contact/ContactCardsSection";
import ContactHeader from "@/components/v2/molecules/landing/contact/ContactHeader";
import CTASection from "@/components/v2/molecules/landing/contact/CTASection";
import { useLanguage } from "@/contexts/LanguageContext";

const Contact = () => {
  const { language } = useLanguage();

  const getLocalizedPath = (path: string) => {
    return language === "en" ? `/en${path}` : path;
  };

  return (
    <Layout>
      <SEOHead
        title="Estancia Corta | Contacto"
        description="¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para ayudarte a encontrar el alojamiento perfecto para ti."
      />
      <ContactHeader />
      <ContactCardsSection />
      <CTASection localizedPath={getLocalizedPath("/propiedades")} />
    </Layout>
  );
};

export default Contact;
